/* PC-HOME-TOUR-43 · Home Tour 1.0.0. No commerce or builder state mutations. */
(() => {
  'use strict';
  const selector = '[data-cc-home-tour]';
  if (window.PCHomeTourV1) { window.PCHomeTourV1.mount(document); return; }
  const instances = new WeakMap();
  const roots = scope => [...(scope.matches?.(selector) ? [scope] : []), ...scope.querySelectorAll(selector)];
  function init(host) {
    if (instances.has(host)) return;
    const track = host.querySelector('[data-home-tour-track]');
    const places = [...host.querySelectorAll('[data-home-tour-place]')];
    const count = host.querySelector('[data-home-tour-count]');
    const previous = host.querySelector('[data-home-tour-prev]');
    const next = host.querySelector('[data-home-tour-next]');
    if (!track || !places.length || !count || !previous || !next) return;
    const mobile = matchMedia('(max-width:700px)');
    const reduced = matchMedia('(prefers-reduced-motion:reduce)');
    const controller = new AbortController();
    const signal = controller.signal;
    let index = 0, scrollTimer = 0, resizeTimer = 0;
    function mark(value) {
      index = (value + places.length) % places.length;
      places.forEach((place, i) => {
        const active = i === index;
        place.classList.toggle('is-active', active);
        place.setAttribute('aria-pressed', String(active));
      });
      const label = `${index + 1} of ${places.length}`;
      if (count.textContent !== label) count.textContent = label;
      host.dataset.homeTourIndex = String(index);
    }
    function align(instant = false) {
      if (!mobile.matches) return;
      const padding = parseFloat(getComputedStyle(track).paddingLeft) || 0;
      const left = track.scrollLeft + places[index].getBoundingClientRect().left - track.getBoundingClientRect().left - padding;
      track.scrollTo({left, behavior:instant || reduced.matches ? 'auto' : 'smooth'});
    }
    function choose(value, focus = false) {
      clearTimeout(scrollTimer);
      mark(value); align();
      if (focus) places[index].focus({preventScroll:true});
    }
    function syncScroll() {
      clearTimeout(scrollTimer);
      if (!mobile.matches) return;
      const origin = track.getBoundingClientRect().left + (parseFloat(getComputedStyle(track).paddingLeft) || 0);
      let nearest = 0, distance = Infinity;
      places.forEach((place, i) => {
        const delta = Math.abs(place.getBoundingClientRect().left - origin);
        if (delta < distance) { distance = delta; nearest = i; }
      });
      mark(nearest);
    }
    places.forEach((place, i) => {
      place.addEventListener('click', () => choose(i), {signal});
      place.addEventListener('keydown', event => {
        const value = event.key === 'ArrowRight' ? i + 1 : event.key === 'ArrowLeft' ? i - 1 : event.key === 'Home' ? 0 : event.key === 'End' ? places.length - 1 : null;
        if (value === null) return;
        event.preventDefault(); choose(value, true);
      }, {signal});
    });
    previous.addEventListener('click', () => choose(index - 1), {signal});
    next.addEventListener('click', () => choose(index + 1), {signal});
    track.addEventListener('scroll', () => { clearTimeout(scrollTimer); scrollTimer = setTimeout(syncScroll, 120); }, {passive:true, signal});
    track.addEventListener('scrollend', syncScroll, {signal});
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => { if (mobile.matches) align(true); else track.scrollLeft = 0; }, 100);
    }, {passive:true, signal});
    const instance = {destroy() {
      controller.abort(); clearTimeout(scrollTimer); clearTimeout(resizeTimer);
      delete host.dataset.homeTourReady; instances.delete(host);
    }};
    instances.set(host, instance); mark(0); host.dataset.homeTourReady = 'true';
  }
  const api = {
    version:'1.0.0',
    mount(scope) { roots(scope).forEach(init); },
    destroy(scope) { roots(scope).forEach(host => instances.get(host)?.destroy()); }
  };
  window.PCHomeTourV1 = api;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => api.mount(document), {once:true});
  else api.mount(document);
  document.addEventListener('shopify:section:load', event => api.mount(event.target));
  document.addEventListener('shopify:section:unload', event => api.destroy(event.target));
})();
